<template>
  <div class="pinyin-preview" v-show="showPopover" :class="{'popover-preview': popover, 'offset-form': offsets}">
    <div class="line" v-for="(item, key) in items" :key="key">
      <slot name="before" :index="key"></slot>
      <div class="item" v-for="(v, k) in item" :key="k">
        <div class="pinyin" v-html="v.pinyin"></div>
        <div class="text" v-html="v.text"></div>
      </div>
      <slot name="after" :index="key"></slot>
    </div>
  </div>
</template>

<script>
import { on, off } from 'element-ui/src/utils/dom'
export default {
  name: 'PinyinPreview',
  // props: ['text', 'pinyin', 'list', 'popover', 'offsets'],
  props: {
    text: String,
    pinyin: String,
    list: Array,
    popover: Boolean,
    container: String,
    offsets: Boolean,
    txtglue: {
      type: String,
      default: ' '
    },
    pinyinglue: {
      type: String,
      default: ' '
    },
  },
  data () {
    return {
      showPopover: true,
      pinyinSeparator: '^'
    }
  },
  computed: {
    isDialog () {
      return /^[^\n:]+:[^\n:]+\n[^\n:]+:/.test(this.text)
    },
    items () {
      if (!this.text || /^\s*$/.test(this.text)) {
        if (this.list && this.list.length > 0) {
          if (Array.isArray(this.list[0])) {
            return this.list
          } else {
            return this.list.map(n => this.compileLineParts(n.text, n.pinyin))
          }
        } else {
          return []
        }
      }
      let lines = []
      let txtParts = this.text.split(/\n\r|\n/)
      // let dialog = this.isDialog
      if (!this.pinyin || /^\s*$/.test(this.pinyin)) {
        for (let row of txtParts) {
          let [txtRow, pinRow = ''] = row.split(this.pinyinSeparator)
          let [txtDlg, txtStr] = this.extractDialog(txtRow)
          let [pinDlg, pinStr] = this.extractDialog(pinRow)
          lines.push(this.compileLineParts(txtDlg, pinDlg).concat(this.compileLineParts(txtStr, pinStr)))
        }
      } else {
        let pinParts = this.pinyin.split(/\n\r|\n/)
        for (let i = 0, c = Math.max(txtParts.length, pinParts.length); i < c; i++) {
          let [txtDlg, txtStr] = this.extractDialog(txtParts.length > i ? txtParts[i] : '')
          let [pinDlg, pinStr] = this.extractDialog(pinParts.length > i ? pinParts[i] : '')
          lines.push(this.compileLineParts(txtDlg, pinDlg).concat(this.compileLineParts(txtStr, pinStr)))
        }
      }
      return lines
    }
  },
  methods: {
    extractDialog (txt) {
      var i = txt.indexOf(':')
      if (i >= 0) {
        return [txt.substring(0, i), txt.substring(i + 1)]
      }
      return ['', txt]
    },
    compileLineParts (txt, pin) {
      let line = []
      if (!txt && !pin) return line
      let txtParts = txt.split(this.txtglue)
      let pinParts = pin.split(this.pinyinglue)
      for (let i = 0, c = Math.max(txtParts.length, pinParts.length); i < c; i++) {
        line.push({
          text: txtParts.length > i ? this.decodeText(txtParts[i]) : '',
          pinyin: pinParts.length > i ? this.decodeText(pinParts[i]): ''
        })
      }
      return line
    },
    handleFocusin (event) {
      this.showPopover = true
    },
    handleFocusout (event) {
      this.showPopover = false
    },
    decodeText(text) {
      return text.replace(/{(%\w+)}/g, (m1, m2) => decodeURI(m2))
    }
  },
  mounted () {
    if (!this.popover) return
    this.showPopover = false
    if (this.container) {
      this.$popoverElements = document.querySelectorAll(this.container)
    } else {
      this.$popoverElements = this.$el.previousElementSibling.querySelectorAll('input,textarea')
    }
    this.$popoverElements.forEach(el => {
      on(el, 'focusin', this.handleFocusin)
      on(el, 'focusout', this.handleFocusout)
    })
  },
  destroyed () {
    if (this.$popoverElements) {
      this.$popoverElements.forEach(el => {
        off(el, 'focusin', this.handleFocusin)
        off(el, 'focusout', this.handleFocusout)
      })
    }
  }
}
</script>

<style lang="scss">
  .pinyin-preview{
    > .line{
      display: flex;
      flex-wrap: wrap;
      margin: -4px;
      > .item{
        padding: 4px;
        text-align: center;
        > div{
          min-height: 18px;
          white-space: nowrap;
        }
      }
    }
  }
  .popover-preview{
    position: absolute;
    left: 0;
    margin-top: 5px;
    background: #fff;
    min-width: 150px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    padding: 12px;
    z-index: 2000;
    color: #606266;
    line-height: 1.4;
    text-align: justify;
    font-size: 14px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    word-break: break-all;
    &.offset-form{
      left: 88px;
      right: 8px;
      margin-top: -15px;
    }
  }
  .sidebar-open .offset-form,
  .el-dialog__body .offset-form{
    left: 100px;
    right: 20px;
  }
</style>
